import ApiClient from './ApiClient'

export default class SubscriptionService {

  constructor() {
    this.apiClient = new ApiClient()
  }

  fetchSubscriptions() {
    return this.apiClient.createAuthed().get('subscription/getsubscriptions')
  }

  getPlusMonthlyPaymentLink() {
    return this.apiClient.createAuthed().get('subscription/getplusmonthlypaymentlink')
  }

  getPlusAnnualPaymentLink() {
    return this.apiClient.createAuthed().get('subscription/getplusannualpaymentlink')
  }

  getBasicMonthlyPaymentLink() {
    return this.apiClient.createAuthed().get('subscription/getbasicmonthlypaymentlink')
  }

  getCustomerPortalUrl(subscriptionId) {
    return this.apiClient.createAuthed().get('subscription/getcustomerportalurl?id=' + subscriptionId)
  }

}